import axios from 'axios';

export function sendDemographicQuestions(params: {studentId: string; demography: {[key: string]: string}}) {
    return axios.put(`${process.env.REACT_APP_API_HOST}/students/${params.studentId}`, {
        demography: params.demography,
    });
}
